/* ExpandIcon.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./ExpandIcon.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import ChevronDownIcon from '@atlaskit/icon/utility/migration/chevron-down';
var expandIconContainerStyle = null;
export function ToolbarExpandIcon() {
  return /*#__PURE__*/React.createElement("span", {
    className: ax(["_1e0c1txw _4cvr1h6o"])
  }, /*#__PURE__*/React.createElement(ChevronDownIcon, {
    label: "",
    color: "currentColor",
    LEGACY_margin: "0 0 0 -8px"
  }));
}